
export default (state: string = 'hpc', { payload, type } : {payload: string, type: string}) => {
  switch (type) {
    case 'SWITCH_SERVICE':
      return payload;

    default:
      return state;
  }
};